import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _deleteSavedPaymentMethodRequest = {};
var _deleteSavedPaymentMethodResponse = {};
var _getSavedPaymentMethodRequest = {};
var _getSavedPaymentMethodResponse = {
    savedPaymentMethod: '_savedPaymentMethod',
};
var _listSavedPaymentMethodsRequest = {};
var _listSavedPaymentMethodsResponse = {
    savedPaymentMethods: '_savedPaymentMethod',
};
var _markSavedPaymentMethodPrimaryRequest = {};
var _markSavedPaymentMethodPrimaryResponse = {};
var _savedPaymentMethod = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateSavedPaymentMethodRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    savedPaymentMethod: '_savedPaymentMethod',
};
var _updateSavedPaymentMethodResponse = {
    savedPaymentMethod: '_savedPaymentMethod',
};
var _upsertSavedPaymentMethodRequest = {
    savedPaymentMethod: '_savedPaymentMethod',
};
var _upsertSavedPaymentMethodResponse = {
    savedPaymentMethod: '_savedPaymentMethod',
};
function resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/payments/saved-payment-methods',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/payments/saved-payment-methods',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/payments/saved-payment-methods',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new SavedPaymentMethod or updates existing one if SavedPaymentMethod already exists for the same site member.
 * To check uniqueness SavedPaymentMethods are compared by credit card expiration year/month, last four digits and bin.
 * If sensitiveInfo.cardSensitiveInfo.temporaryToken was passed than service will eventually create a persi from it.
 */
export function upsertSavedPaymentMethod(payload) {
    var _a = serializer(_upsertSavedPaymentMethodRequest, { _savedPaymentMethod: _savedPaymentMethod }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_upsertSavedPaymentMethodResponse, {
        _savedPaymentMethod: _savedPaymentMethod,
    }).fromJSON;
    function __upsertSavedPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.saved_payment_method',
            method: 'POST',
            methodFqn: 'wix.payments.saved_payment_methods.v1.SavedPaymentMethodService.UpsertSavedPaymentMethod',
            url: resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl({
                protoPath: '/v1/saved-payment-methods/upsert',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __upsertSavedPaymentMethod.fromReq = fromReq;
    __upsertSavedPaymentMethod.__isAmbassador = true;
    return __upsertSavedPaymentMethod;
}
/** Returns SavedPaymentMethod by ID. */
export function getSavedPaymentMethod(payload) {
    var _a = serializer(_getSavedPaymentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSavedPaymentMethodResponse, {
        _savedPaymentMethod: _savedPaymentMethod,
    }).fromJSON;
    function __getSavedPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.saved_payment_method',
            method: 'GET',
            methodFqn: 'wix.payments.saved_payment_methods.v1.SavedPaymentMethodService.GetSavedPaymentMethod',
            url: resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl({
                protoPath: '/v1/saved-payment-methods/{savedPaymentMethodId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSavedPaymentMethod.fromReq = fromReq;
    __getSavedPaymentMethod.__isAmbassador = true;
    return __getSavedPaymentMethod;
}
/** Deletes SavedPaymentMethod by ID. */
export function deleteSavedPaymentMethod(payload) {
    var _a = serializer(_deleteSavedPaymentMethodRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSavedPaymentMethodResponse, {}).fromJSON;
    function __deleteSavedPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.saved_payment_method',
            method: 'DELETE',
            methodFqn: 'wix.payments.saved_payment_methods.v1.SavedPaymentMethodService.DeleteSavedPaymentMethod',
            url: resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl({
                protoPath: '/v1/saved-payment-methods/{savedPaymentMethodId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSavedPaymentMethod.fromReq = fromReq;
    __deleteSavedPaymentMethod.__isAmbassador = true;
    return __deleteSavedPaymentMethod;
}
/** Lists SavedPaymentMethods ordered by update date descending. */
export function listSavedPaymentMethods(payload) {
    var _a = serializer(_listSavedPaymentMethodsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSavedPaymentMethodsResponse, {
        _savedPaymentMethod: _savedPaymentMethod,
    }).fromJSON;
    function __listSavedPaymentMethods(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.saved_payment_method',
            method: 'GET',
            methodFqn: 'wix.payments.saved_payment_methods.v1.SavedPaymentMethodService.ListSavedPaymentMethods',
            url: resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl({
                protoPath: '/v1/saved-payment-methods',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSavedPaymentMethods.fromReq = fromReq;
    __listSavedPaymentMethods.__isAmbassador = true;
    return __listSavedPaymentMethods;
}
/** Updates SavedPaymentMethod. Only fields listed in field_mask are updated. */
export function updateSavedPaymentMethod(payload) {
    var _a = serializer(_updateSavedPaymentMethodRequest, { _savedPaymentMethod: _savedPaymentMethod }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSavedPaymentMethodResponse, {
        _savedPaymentMethod: _savedPaymentMethod,
    }).fromJSON;
    function __updateSavedPaymentMethod(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.saved_payment_method',
            method: 'PATCH',
            methodFqn: 'wix.payments.saved_payment_methods.v1.SavedPaymentMethodService.UpdateSavedPaymentMethod',
            url: resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl({
                protoPath: '/v1/saved-payment-methods/{savedPaymentMethod.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSavedPaymentMethod.fromReq = fromReq;
    __updateSavedPaymentMethod.__isAmbassador = true;
    return __updateSavedPaymentMethod;
}
/**
 * Marks SavedPaymentMethod as primary for site member who's the owner of this SavedPaymentMethod.
 * Primary SavedPaymentMethod is selected by default during the checkout.
 * For every site member there can be at most one primary SavedPaymentMethod,
 * so when one SavedPaymentMethod is marked as primary previous one is automatically unmarked.
 */
export function markSavedPaymentMethodPrimary(payload) {
    var _a = serializer(_markSavedPaymentMethodPrimaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markSavedPaymentMethodPrimaryResponse, {}).fromJSON;
    function __markSavedPaymentMethodPrimary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.payments.saved_payment_methods.v1.saved_payment_method',
            method: 'GET',
            methodFqn: 'wix.payments.saved_payment_methods.v1.SavedPaymentMethodService.MarkSavedPaymentMethodPrimary',
            url: resolveWixPaymentsSavedPaymentMethodsV1SavedPaymentMethodServiceUrl({
                protoPath: '/v1/saved-payment-methods/{savedPaymentMethodId}/mark-primary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markSavedPaymentMethodPrimary.fromReq = fromReq;
    __markSavedPaymentMethodPrimary.__isAmbassador = true;
    return __markSavedPaymentMethodPrimary;
}
//# sourceMappingURL=http.impl.js.map